import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Footer from '../footer/Footer';
import Header from '../header/Header';
import HeroImage from '../hero-image/HeroImage';
import './Layout.css';
import { useCartDrawer } from '../../context/shopContext';


const Layout = ({
  children,
  heroImage,
  navigation,
  footer,
  translations,
  locale,
  slug,
  backTo,
  finnishLanguage,
  topTitle
}) => {
  const [burgerMenuOpen, setBurgerMenuOpen] = useState(false);
  const { cartDrawerOpen, setCartDrawerOpen } = useCartDrawer();
  // useEffect(() => {
  //   if (burgerMenuOpen) {
  //     document.body.style.overflow = 'hidden';
  //     document.body.querySelector('div.gatsby-image-wrapper').style.opacity =
  //       '0.5';
  //   } else if (cartDrawerOpen) {
  //     document.body.style.overflow = 'hidden';
  //     document.body.querySelector('div.gatsby-image-wrapper').style.opacity =
  //       '0.5';
  //     const header = document.body.querySelector('header');
  //     const firstDiv = header.querySelectorAll('div')[0];
  //     firstDiv.style.opacity = '0.5';
  //     firstDiv.style.pointerEvents = 'none';
  //   } else if (!burgerMenuOpen && !cartDrawerOpen) {
  //     document.body.style.overflow = '';
  //     document.body.querySelector('div.gatsby-image-wrapper').style.opacity =
  //       '';
  //     const header = document.body.querySelector('header');
  //     const firstDiv = header.querySelectorAll('div')[0];
  //     if (firstDiv.style.opacity === '0.5') {
  //       firstDiv.style.opacity = '';
  //       firstDiv.style.pointerEvents = 'unset';
  //     }
  //   }
  // }, [burgerMenuOpen, cartDrawerOpen]);

  return slug !== null ? (
    <>
      <Header
        navigation={navigation}
        currentPage={slug}
        translations={translations}
        locale={locale}
        finnishLanguage={finnishLanguage}
        backTo={backTo}
        burgerMenuOpen={burgerMenuOpen}
        setBurgerMenuOpen={setBurgerMenuOpen}
        cartDrawerOpen={cartDrawerOpen}
        setCartDrawerOpen={setCartDrawerOpen}
        topTitle={topTitle}
      />
      {!!heroImage && <HeroImage image={heroImage} />}
      <main>
        <div
          className={`content ${
            burgerMenuOpen || cartDrawerOpen ? 'opaque' : ''
          }`}
        >
          {children}
        </div>
        <Footer footer={footer} finnishLanguage={finnishLanguage} />
      </main>
    </>
  ) : (
    <>
    <Header
      navigation={navigation}
      currentPage={slug}
      translations={translations}
      locale={locale}
      finnishLanguage={finnishLanguage}
      backTo={backTo}
      burgerMenuOpen={burgerMenuOpen}
      setBurgerMenuOpen={setBurgerMenuOpen}
      cartDrawerOpen={cartDrawerOpen}
      setCartDrawerOpen={setCartDrawerOpen}
      topTitle={topTitle}
    />
    <main>
      <div
        className={`content ${
          burgerMenuOpen || cartDrawerOpen ? 'opaque' : ''
        }`}
      >
        {children}
      </div>
      <Footer footer={footer} finnishLanguage={finnishLanguage} />
    </main>
  </>
  );
};

Layout.propTypes = {
  children: PropTypes.array.isRequired,
  heroImage: PropTypes.object,
  navigation: PropTypes.array.isRequired,
  footer: PropTypes.object.isRequired,
  translations: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  slug: PropTypes.string,
  backTo: PropTypes.string.isRequired,
  finnishLanguage: PropTypes.bool.isRequired,
  topTitle: PropTypes.string.isRequired
};

export default Layout;
